const CustomizedSolutions = () => {
    return (
      <div>
        <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          
            <div className="flex flex-col justify-center">
              <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                Customised Solutions
              </h1>
              <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                All that TCS Mail Management Service needs is data that requires customisation according to the customers’ 
                devised formats to be transformed in documents, such as bills, letters or statements etc. From that point on, 
                TCS project managers make sure that each job adheres to the process and quality procedures ensuring high levels 
                of accuracy, to provide customers with the exact custom solution they want.
              </p>
              
                
            </div>
            <div className="flex-1 flex flex-col justify-center sm:mt-[0rem] mt-[1rem]">
              <img src="/MMs/customizedsolutionsinsid.jpg" alt="" className="max-w-[100%] rounded-md"/>
            </div>
          </div>
            
        </div>
      </div>
    );
  };
  
  export default CustomizedSolutions;